import { request } from '../../../api/request';
import urls from './url';

export function sendSms(data) {
    return request({
        url: urls.sendSms,
        method: 'get',
        params: data,
        isNeedLoading: true,
        isNeedToken: false,
    });
}

export function gtInit(data) {
    return request({
        url: urls.gtInit,
        method: 'get',
        params: data,
        isNeedLoading: true,
        isNeedToken: false,
    });
}

export function registerByPhone(data) {
    return request({
        url: urls.registerByPhone,
        method: 'get',
        params: data,
        isNeedLoading: true,
        isNeedToken: false,
    });
}

export function getEntry(data) {
    return request({
        url: urls.getEntry,
        method: 'get',
        params: data,
        isNeedLoading: true,
        isNeedToken: false,
    });
}

export function getShareIcon(data) {
    return request({
        url: urls.getShareIcon,
        method: 'get',
        params: data,
        isNeedLoading: false,
        isNeedToken: false,
    });
}

export function getShareInfo(data) {
    return request({
        url: urls.getShareInfo,
        method: 'get',
        params: data,
        isNeedLoading: false,
        isNeedToken: false,
    });
}
